import { Component, Renderer2 } from '@angular/core';
import { PropertyUnit } from '../../_core/_interface/unit';
import { AuthService } from 'src/app/_services/auth.service';
import { User } from 'src/app/_core/_interface/user';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/compat/storage';
import { AppFirestoreService } from 'src/app/_services/app-firestore.service';
import { Observable, finalize, map, switchMap } from 'rxjs';
import { DataService } from 'src/app/_services/data.service';
import { randomString } from 'src/app/_core/_function/randomid';
import { SyeService } from 'src/app/_services/sye.service';
import { EMPTY } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

interface CalculatedProperty extends PropertyUnit {
  buildTitle: any;
  totalCost: number;
  parkingTotalCost: number;
  shelterTotalCost: number;
  numberOfStoragesSpaces: number;
}


@Component({
  selector: 'app-price-calculator-housing',
  templateUrl: './price-calculator-housing.component.html',
  styleUrls: ['./price-calculator-housing.component.scss']
})
export class PriceCalculatorHousingComponent {
  showSearchResults: any;
  units: any[] = [];
  // exampleProperties: PropertyUnit[] = [
  //   {
  //     unitNumber: "2",
  //     propertyDirection: "North",
  //     type: 'office',
  //     officeArea: 120,
  //     shelterArea: 30,
  //     constructionCost: 300000,
  //     parkingConstructionCost: 50000,
  //     balconiesSize: 20,
  //     numberOfParkingSpaces: 0,
  //     defaultPrice: 100,
  //     buildingId: 'OXMwZtbVweQjPVD'
  //   },
  //   {
  //     unitNumber: "3",
  //     propertyDirection: "North",
  //     type: 'storage',
  //     storageArea: 15,
  //     constructionCost: 300000,
  //     parkingConstructionCost: 50000,
  //     defaultPrice: 100,
  //     buildingId: 'OXMwZtbVweQjPVD'
  //   },
  //   {
  //     unitNumber: "4",
  //     propertyDirection: "North",
  //     officeArea: 120,
  //     type: 'office',
  //     shelterArea: 30,
  //     constructionCost: 300000,
  //     parkingConstructionCost: 50000,
  //     balconiesSize: 20,
  //     numberOfParkingSpaces: 0,
  //     defaultPrice: 100,
  //     buildingId: 'OXMwZtbVweQjPVD'
  //   },
  //   {
  //     unitNumber: "5",
  //     propertyDirection: "North",
  //     type: 'storage',
  //     storageArea: 15,
  //     constructionCost: 300000,
  //     parkingConstructionCost: 50000,
  //     defaultPrice: 100,
  //     buildingId: 'OXMwZtbVweQjPVD'
  //   }
  //   // Additional example properties can be added here
  // ];

  // firstName: string = '';
  formData = {
    personalId: '',
    lastName: '',
    firstName: '',
    mobilePhone: '',
    city: '',
    street: '',
    buildingNumber: '',
    email: '',
  };

  unitNumber: string = '';
  officeLandCostPerSqM: number | null = null;
  officeLandCostPerSqMScope: any;

  parkingSpaceCost: number = 0;
  numberOfParkingSpaces: number | null = null;
  numberOfStoragesSpaces: number | null = null;
  totalArea: number = 0;
  unitTotalPrice: number = 0;
  averagePricePerSqM: number | null = null;
  parkingConstructionCost: number = 0;
  date = new Date();
  calculatedProperties: CalculatedProperty[] = []; // Array to store properties with their calculated costs
  attachedshelterAreaPricePerSqM: number | null = null; // New property for attached common area price per sqm
  shelterArea: number | null = null;
  parkingTotalCost: number = 0;
  shelterTotalCost: number | null = null;
  attachedBalconyAreaPricePerSqM: number | null = null;
  attachedStorageAreaPricePerSqM: number | null = null;
  balconiesSize: number | null = null;
  storageArea: number | null = null;
  storageTotalCost: number = 0;
  balconyTotalCost: number = 0;
  constructionTotalCost: number = 0;
  sumOfTotalCostsExcludeTaxes: number = 0;
  sumOfTotalCostsExcludeConstractionExcludeTaxes: number = 0;
  lawyerFee: number = 0;
  totalAreaExludeParking: number | null = null;
  user: User;
  allowAddStorage: boolean = false;
  compId: string;
  projuId: string;
  task: AngularFireUploadTask;
  filesBaseUrl = `https://firebasestorage.googleapis.com/v0/b/${environment.firebase.storageBucket}/o/`;
  // Progress monitoring
  percentage: Observable<number>;
  snapshot: Observable<any>;
  // Download URL
  downloadURL: Observable<string>;
  offer: any = {};
  subscription: any;
  buildings: any[] = [];
  projId: string = '';
  proj: any;
  parkingSpaceCostScope: any;
  storageSpaceCostScope: any;
  ClientNumber: any;
  OpportunityNum: any;
  SalesAgentFromCRM: string = '';
  Agency: string = '';
  ProjectNumber: number = 0;

  marketingCommissionTotalCost: number = 0;
  marketingCommissionPerSqM: number = 130;
  defaultPrice: number = 0;
  parking: any;
  storages: any;
  storageSpaceCost: number = 0;
  storageSpaceTotalCost: number = 0;
  constractionStorageCost: number = 0;
  totalParkingCostWithConstruction: number = 0;
  totalConstractionStorageCost: number = 0;
  totalConstractionParkingCost: number = 0;
  unitsStatusAndStorageParkingAmountFromCRM: any = {};
  totalCostIncludeAllExludeTaxes: number = 0;
  showPreview: boolean = false;
  showPromt: boolean = false;
  blob: any;
  discountPercentage: number = 0;
  discountPercentageScope: any;
  sumOfTotalCostsExcludeConstraction: number = 0;
  projTitle: string = '';


  findPropertyByUnitNumber(unitNumber: string): PropertyUnit | undefined {
    return this.units.find(property => property.number === unitNumber);
  }

  constructor(private dataService: DataService, public auth: AuthService, private route: ActivatedRoute, private router: Router, private storage: AngularFireStorage,
    private db: AppFirestoreService,
    private renderer: Renderer2,
    private sye: SyeService,
    private cd: ChangeDetectorRef) {
    this.compId = this.route.snapshot.paramMap.get('id');
    this.projuId = this.route.snapshot.paramMap.get('idp');
  }


  ngOnInit() {
    // this.dataService.getSpecProject(this.projuId).subscribe(proj => {
    //   this.projId = proj[0].id;
    //   this.dataService.getItemsByProjId(this.projId).subscribe(items => {
    //     this.buildings = items;
    //     if(this.buildings.length > 0) {
    //       let floors = this.buildings[0].floors;
    //       floors.forEach(floor => {
    //         floor.floor.flats.forEach(units => {
    //           this.units.push(units);
    //         });
    //       });
    //     }
    //   });
    // });
    this.route.queryParams.subscribe(params => {
      // this.phone = params['phone'] || null;


      this.ClientNumber = params['ClientNumber'];
      this.OpportunityNum = params['OpportunityNum'];
      this.formData.firstName = params['FirstName'] || null;
      this.formData.lastName = params['LastName'] || null;
      this.formData.mobilePhone = params['Phone'] || null;
      this.formData.email = params['Email'] || null;
      this.SalesAgentFromCRM = params['SalesAgent'] || null;
      this.Agency = params['Agency'] || null;
      this.ProjectNumber = params['ProjectNumber'] || null;

    });
    let projectDetailsFromCrm = this.fetchProjectDetails(25000000);

    console.log(projectDetailsFromCrm)
    //     ClientNumber = מספר לקוח הייפר
    // OpportunityNum = מספר הזדמנות מכירה
    // FirstName = שם פרטי
    // LastName = שם משפחה
    // Phone = טלפון (סלולארי)
    // Email
    // SalesAgent = סוכן מכירות אחראי בהייפר
    // Agency = שם סניף הלקוח
    // ProjectNumber = מספר הפרויקט בהייפר.
    let counter = 0;

    this.dataService.getSpecProject(this.projuId).pipe(
      switchMap(proj => {
        this.projId = proj[0].id;
        this.proj = proj[0];
        this.projTitle = proj[0].title;
        this.parking = proj[0].parking;
        // this.storages = proj[0].storage;
        this.storages = 0;
        this.officeLandCostPerSqMScope = proj[0].officeLandCostPerSqMScope;
        this.discountPercentageScope = proj[0].discountPercentageScope;
        
        if (counter === 1) {
          return EMPTY;
        }
        
        this.parkingSpaceCostScope = proj[0].parkingSpaceCostScope;
        this.storageSpaceCostScope = proj[0].storageSpaceCostScope;
        return this.dataService.getItemsByProjId(this.projId);
      }),
      map(items => {
        this.buildings = items;
        if (this.buildings.length > 0) {
          this.buildings.forEach(build => {
            let floors = [];
            let buildTitle = '';
            let builUid='';
            let builId='';
            buildTitle = build.name;
            builUid = build.uid;
            builId = build.id;
            floors.push(build.floors);
            console.log('UNITS');
            floors.forEach(floorArray => {
              floorArray.forEach(floor => {
                floor.floor.flats.forEach(unit => {
                  unit.unitNumber = unit.number;
                  unit.officeArea = unit.flatSize;
                  unit.buildTitle = buildTitle;
                  // unit.buildUid = builUid;
                  unit.buildingId = builUid;
                  if (this.units.indexOf(unit) === -1) {
                    this.units.push(unit);
                    // this.units = [...this.units, unit]; // Immutability fix
                  }
                });
              });
            });

          });
    

        }
        counter = 1;
        return this.units;
      }),
      catchError(err => {
        console.error('Error:', err);
        return EMPTY;
      })
    ).subscribe(() => {
      // Force change detection after observable chain finishes
      this.cd.detectChanges();
    });
    
      

    // const getBuild = this.dataService.getSpecBuilding(this.buildings[0].uid).subscribe(items => {
    // });


    this.user = this.auth.currentUserValue;
    // this.exampleProperties.filter(unit =>{
    //   this.units.push(unit.unitNumber);
    // })
  }

  sendWhatsAppMessage(userId: string, pathToOfferPdf: string, userMobilePhone: number, appartment: any) {
    const greeting =   ' פרויקט '  + this.projTitle;
    const buildingName = 'בניין: ' + appartment.buildTitle;
    const unitName = 'נכס להמחשה: ' + appartment.number;
    const visualUnitsText = 'נכסים להמחשה';
    const offerPdf = 'הצעה בקובץ PDF';
    const happyService = 'נשמח לעמוד לשירותכם';
    const link = `https://spirical.net/company/u/XcaWLkXt9N1Q45WBg8AA/WrJLJ1cKksmPZua/calculator-offer/${userId}`;
  
    // Construct the full message without encoding line breaks
    const message = `${greeting}\n${buildingName}\n${unitName}\n${link}\n${offerPdf}\n${pathToOfferPdf}\n${happyService}`;
  
    const phoneNumber = '+972'+ userMobilePhone; // Recipient phone number
  
    // Encode the message as a whole to preserve spaces and line breaks correctly
    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}&phone=${encodeURIComponent(phoneNumber)}`;
  
    // Open the URL in a new tab
    window.open(whatsappUrl, '_blank');
  }

  onSubmit(data: any) {
    console.log('Form submitted:', data);
  }

  choisenUnitNumber($event) {
    this.unitNumber = $event;
  }

  addProperty(): void {
    if(this.calculatedProperties.length > 0){
      if (this.numberOfParkingSpaces) {
        this.parkingTotalCost = this.parkingSpaceCost * this.numberOfParkingSpaces;
        // this.sumOfTotalCostsExcludeConstraction = this.unitTotalPrice + this.parkingTotalCost + (this.parkingConstructionCost * this.numberOfParkingSpaces);
        this.totalConstractionParkingCost = this.parkingConstructionCost * this.numberOfParkingSpaces;
        this.totalCostIncludeAllExludeTaxes = this.unitTotalPrice + this.constructionTotalCost + this.totalConstractionParkingCost + this.parkingTotalCost;
        this.sumOfTotalCostsExcludeConstractionExcludeTaxes = this.unitTotalPrice + this.parkingTotalCost;
        this.lawyerFee = (this.totalCostIncludeAllExludeTaxes/1.17) * 0.015 * 1.18;
      }
      window.alert('יא אפשר להכניס כמה נכסים להצעה אחד');
      return;
    }
    let property = this.findPropertyByUnitNumber(this.unitNumber);
    this.defaultPrice = property.defaultPrice;
    // if (this.officeLandCostPerSqM === null || this.officeLandCostPerSqM < this.officeLandCostPerSqMScope.officeLandCostPerSqMFrom
    //   || this.officeLandCostPerSqM > this.officeLandCostPerSqMScope.officeLandCostPerSqMUntill) {
    //   window.alert('המחיר של קרקע לא בטווח המותר');
    //   return;
    // }
    if (this.discountPercentage === null || this.discountPercentage < this.discountPercentageScope.discountPercentageFrom
      || this.discountPercentage > this.discountPercentageScope.discountPercentageUntill) {
      window.alert('אחוז המחה לא בטווח המותר');
      return;
    } else {
      if(this.discountPercentage !== 0){
        this.defaultPrice = this.defaultPrice - ((this.defaultPrice / 100) * this.discountPercentage);
      }
    }
    if ((this.parkingSpaceCostScope === null && this.numberOfParkingSpaces > 0) || this.parkingSpaceCost < this.parkingSpaceCostScope.parkingSpaceCostFrom
      || this.parkingSpaceCost > this.parkingSpaceCostScope.parkingSpaceCostUntill) {
      window.alert('המחיר החניה לא בטווח המותר');
      return;
    }
    // if (this.storageSpaceCostScope === null || this.storageSpaceCost < this.storageSpaceCostScope.storageSpaceCostFrom
    //   || this.storageSpaceCost > this.storageSpaceCostScope.storageSpaceCostUntill) {
    //   window.alert('המחיר מחסן לא בטווח המותר');
    //   return;
    // }


    if (property === undefined) {
      if (this.officeLandCostPerSqM === null) {
        window.alert('לא קיים נכס כזה');
        return;
      } else {
        if (this.calculatedProperties.length > 0) {
          property = this.calculatedProperties[0];
          this.removeProperty(property);
        }
      }
    }
    // if (property.type === 'storage') {
    if (this.storages) {
      this.allowAddStorage = false;
      this.calculatedProperties.forEach(property => {
        if (property.type === 'office' || property.type === '') {
          this.allowAddStorage = true;
          // return;
        }
      })
    }
    // else {
    //   this.allowAddStorage = true
    // }
    let ifPropertyExist = this.calculatedProperties.find(property => property.unitNumber === this.unitNumber);


    if (!ifPropertyExist) {

      if (property) {
        if(property.parkingConstructionCost && !this.numberOfParkingSpaces){
          alert('להוסיף חניה');
          return;
        }
        // if (this.numberOfParkingSpaces && !this.parkingSpaceCost) {
        //   alert('לא הוספת עלות חניה');
        //   return;
        // }
        if (this.unitsStatusAndStorageParkingAmountFromCRM.soldUnits) {
          if (this.unitsStatusAndStorageParkingAmountFromCRM.soldUnits.indexOf(property.unitNumber) >= 0) {
            alert(" :הנכס" + " " + property.unitNumber + " נמכר")
            return;
          }
        }
        if (this.unitsStatusAndStorageParkingAmountFromCRM.avalablePrkingAmount) {
          if (this.unitsStatusAndStorageParkingAmountFromCRM.avalablePrkingAmount < this.numberOfParkingSpaces) {
            alert(this.unitsStatusAndStorageParkingAmountFromCRM.avalablePrkingAmount + " נשרו חניות")
            return
          }
        }
        if (this.unitsStatusAndStorageParkingAmountFromCRM.avalableStorageAmount) {
          if (this.unitsStatusAndStorageParkingAmountFromCRM.avalableStorageAmount < this.numberOfStoragesSpaces) {
            alert(this.unitsStatusAndStorageParkingAmountFromCRM.avalableStorageAmount + " נשרו מחסנים")
            return
          }
        }
        let totalCost = this.defaultPrice;

        // if (this.parkingSpaceCost !== null && this.numberOfParkingSpaces !== null) {
        //   totalCost += this.parkingSpaceCost * this.numberOfParkingSpaces;
        // }
        if (!ifPropertyExist) {
          this.calculatedProperties.push({
            ...property,
            totalCost: totalCost,
            defaultPrice: this.defaultPrice,
            parkingTotalCost: this.parkingTotalCost,
            shelterTotalCost: this.shelterTotalCost,
            numberOfStoragesSpaces: this.numberOfStoragesSpaces,
            buildTitle: property.buildTitle
          });
        }
        console.log(this.calculatedProperties);
        if (property.officeArea && !ifPropertyExist) {
          this.totalArea += property.officeArea;
        }
        if (totalCost && !ifPropertyExist) {
          this.unitTotalPrice += totalCost;
        }
        if (property.shelterArea && !ifPropertyExist) {
          this.shelterArea += property.shelterArea;
        }
        if (property.balconiesSize && !ifPropertyExist) {
          this.balconiesSize += property.balconiesSize;
        }
        if (property.storageArea && !ifPropertyExist) {
          this.storageArea += property.storageArea;
        }
        if (this.parking.constractionCost) {
          this.parkingConstructionCost = this.parking.constractionCost;
        }
        // if (this.storages.constractionCost) {
        //   this.constractionStorageCost = this.storages.constractionCost;
        // }
        if (!ifPropertyExist) {
          this.constructionTotalCost += property.constructionCost;
        }
        if (this.numberOfStoragesSpaces) {
          this.totalConstractionStorageCost = this.constractionStorageCost * this.numberOfStoragesSpaces;
        }
        if (this.numberOfParkingSpaces) {
          this.totalConstractionParkingCost = this.parkingConstructionCost * this.numberOfParkingSpaces;
        }

        this.averagePricePerSqM = this.officeLandCostPerSqM;
        // Calculate the attached common area price per sqm as 20% less than the office area price per sqm
        this.attachedshelterAreaPricePerSqM = this.officeLandCostPerSqM * 0.8;
        this.attachedBalconyAreaPricePerSqM = this.officeLandCostPerSqM * 0.5;
        // this.attachedStorageAreaPricePerSqM = this.officeLandCostPerSqM * 0.9;
        // this.attachedBalconyAreaPricePerSqM = this.balconiesSize * this.attachedBalconyAreaPricePerSqM;
        if (this.numberOfParkingSpaces) {
          this.parkingTotalCost = this.parkingSpaceCost * this.numberOfParkingSpaces;
        }

        if (this.numberOfStoragesSpaces) {
          this.storageSpaceTotalCost = this.storageSpaceCost * this.numberOfStoragesSpaces;
        }
        if (totalCost && ifPropertyExist) {
          // this.unitTotalPrice = this.totalArea * this.averagePricePerSqM;
          this.unitTotalPrice = this.defaultPrice;
        }
        this.constractionStorageCost = this.storages.constractionCost;
        this.shelterTotalCost = this.shelterArea * this.attachedshelterAreaPricePerSqM;
        this.storageSpaceTotalCost = this.storageSpaceCost * this.numberOfStoragesSpaces;
        this.balconyTotalCost = this.balconiesSize * this.attachedBalconyAreaPricePerSqM;
        this.sumOfTotalCostsExcludeTaxes = this.unitTotalPrice + this.parkingTotalCost + this.totalConstractionParkingCost + this.shelterTotalCost + this.storageSpaceTotalCost + this.totalConstractionStorageCost + this.balconyTotalCost + this.constructionTotalCost;
        this.sumOfTotalCostsExcludeConstractionExcludeTaxes = this.unitTotalPrice + this.parkingTotalCost;
        this.sumOfTotalCostsExcludeConstraction = this.unitTotalPrice + this.parkingTotalCost;
        this.totalAreaExludeParking = this.totalArea + this.shelterArea + this.balconiesSize + this.storageArea;
        if(+property.numberOfRooms === 3){
          this.marketingCommissionTotalCost = 12000;
        }
        if(+property.numberOfRooms === 4){
          this.marketingCommissionTotalCost = 14000;
        }
        if(+property.numberOfRooms > 4){
          this.marketingCommissionTotalCost = 16000;
        }
        // this.marketingCommissionTotalCost = this.marketingCommissionPerSqM * this.totalArea;
        this.totalParkingCostWithConstruction = (this.parkingConstructionCost + this.parkingSpaceCost) * this.numberOfParkingSpaces;
        this.totalCostIncludeAllExludeTaxes = this.unitTotalPrice + this.constructionTotalCost + this.totalConstractionParkingCost + this.parkingTotalCost;
        this.lawyerFee = (this.totalCostIncludeAllExludeTaxes/1.17) * 0.015 * 1.18;
      }
    } 
    if (this.numberOfParkingSpaces) {
      this.parkingTotalCost = this.parkingSpaceCost * this.numberOfParkingSpaces;
      this.totalConstractionParkingCost = this.parkingConstructionCost * this.numberOfParkingSpaces;
    }
    this.totalCostIncludeAllExludeTaxes = this.unitTotalPrice + this.constructionTotalCost + this.totalConstractionParkingCost + this.parkingTotalCost;
    let offices: any = this.calculatedProperties.filter(property => property.type === 'office' || property.type === '');
    if (offices.length > 0 && this.numberOfParkingSpaces > 0) {
      let reminder = this.numberOfParkingSpaces % offices.length
      let howmuchParkingsInEachUnit = Math.floor(this.numberOfParkingSpaces / offices.length);
      // let remainingParkingCounter = this.numberOfParkingSpaces;
      if (this.numberOfParkingSpaces >= offices.length) {
        this.calculatedProperties.forEach((property, index) => {
          property.numberOfParkingSpaces = 0;
          if (reminder) {
            if (index === 0) {
              property.numberOfParkingSpaces += reminder;
            }
          }
          if (property.type === 'office' || property.type === '') {
            property.numberOfParkingSpaces += howmuchParkingsInEachUnit;
          }
          // if (this.numberOfParkingSpaces) {
          //   this.parkingTotalCost = this.parkingSpaceCost * this.numberOfParkingSpaces;
          // }
          this.sumOfTotalCostsExcludeConstraction = this.unitTotalPrice + this.parkingTotalCost;
        })
      } else {
        this.calculatedProperties.forEach((property, index) => {
          property.numberOfParkingSpaces = 0;
          if (index < this.numberOfParkingSpaces) {
            property.numberOfParkingSpaces = 1;
          }

        })
      }
    }
    if (offices.length > 0 && this.numberOfStoragesSpaces > 0) {
      let reminder = this.numberOfStoragesSpaces % offices.length
      let howmuchStoragesInEachUnit = Math.floor(this.numberOfStoragesSpaces / offices.length);
      if (this.numberOfStoragesSpaces >= offices.length) {
        this.calculatedProperties.forEach((property, index) => {
          property.numberOfStoragesSpaces = 0;
          if (reminder) {
            if (index === 0) {
              property.numberOfStoragesSpaces += reminder;
            }
          }
          if (property.type === 'office' || property.type === '') {
            property.numberOfStoragesSpaces += howmuchStoragesInEachUnit;
          }
        })
      } else {

        this.calculatedProperties.forEach((property, index) => {
          property.numberOfStoragesSpaces = 0;
          if (index < this.numberOfStoragesSpaces) {
            property.numberOfStoragesSpaces = 1;
          }

        })

      }
    }
  }

  officeLandCostPerSqMScopeF() {
    this.proj.officeLandCostPerSqMScope = this.officeLandCostPerSqMScope;
    console.log(this.proj.officeLandCostPerSqMScope);
    this.dataService.updateItem(this.proj, 'markers/');
  }
  discountPercentageScopeF() {
    this.proj.officeLandCostPerSqMScope = this.officeLandCostPerSqMScope;
    console.log(this.proj.officeLandCostPerSqMScope);
    this.dataService.updateItem(this.proj, 'markers/');
  }
  
  parkingSpaceCostScopeF() {
    this.proj.parkingSpaceCostScope = this.parkingSpaceCostScope;
    console.log(this.proj.parkingSpaceCostScope);
    this.dataService.updateItem(this.proj, 'markers/');
  }
  storageSpaceCostScopeF() {
    this.proj.storageSpaceCostScope = this.storageSpaceCostScope;
    console.log(this.proj.storageSpaceCostScope);
    this.dataService.updateItem(this.proj, 'markers/');
  }
  closeSearch() {
    this.showSearchResults = false;
  }
  removeProperty(property): void {
    this.unitTotalPrice = 0;
    if (property.type === 'office' || property.type === '') {
      let ifLastOffice = this.calculatedProperties.filter(property => property.type === 'office' || property.type === '');
      if (ifLastOffice.length === 1) {
        this.calculatedProperties = [];
        this.totalArea = 0;
        this.unitTotalPrice = 0;
        this.shelterArea = 0;
        this.balconiesSize = 0;
        this.storageArea = 0;
        this.parkingConstructionCost = 0;
        this.constructionTotalCost = 0;
        return;
      }
    }
    let index = this.calculatedProperties.findIndex(propertyInArray => propertyInArray.unitNumber === property.unitNumber);
    if (index > -1) {
      if (property) {
        let totalCost = property.officeArea * this.officeLandCostPerSqM;
        this.calculatedProperties.splice(index, 1);
        console.log(this.calculatedProperties);
        if (property.officeArea) {
          this.totalArea += -property.officeArea;
        }
        if (totalCost) {
          this.unitTotalPrice += -totalCost;
        }
        if (property.shelterArea) {
          this.shelterArea += -property.shelterArea;
        }
        if (property.balconiesSize) {
          this.balconiesSize += -property.balconiesSize;
        }
        if (property.storageArea) {
          this.storageArea += -property.storageArea;
        }
        if (property.parkingConstructionCost) {
          this.parkingConstructionCost = -property.parkingConstructionCost;
        }
        this.constructionTotalCost += -property.constructionCost;
        this.averagePricePerSqM = this.officeLandCostPerSqM;
        // Calculate the attached common area price per sqm as 20% less than the office area price per sqm
        this.attachedshelterAreaPricePerSqM = this.officeLandCostPerSqM * 0.8;
        this.attachedBalconyAreaPricePerSqM = this.officeLandCostPerSqM * 0.5;
        // this.attachedStorageAreaPricePerSqM = this.officeLandCostPerSqM * 0.9;
        // this.attachedBalconyAreaPricePerSqM = this.balconiesSize * this.attachedBalconyAreaPricePerSqM;
        if (this.numberOfParkingSpaces) {
          this.parkingTotalCost = this.parkingSpaceCost * this.numberOfParkingSpaces;
        }

        this.shelterTotalCost = this.shelterArea * this.attachedshelterAreaPricePerSqM;
        this.storageTotalCost = this.storageSpaceCost * this.attachedStorageAreaPricePerSqM;
        this.balconyTotalCost = this.balconiesSize * this.attachedBalconyAreaPricePerSqM;
        this.sumOfTotalCostsExcludeTaxes = this.unitTotalPrice + this.parkingTotalCost + this.shelterTotalCost + this.storageTotalCost + this.balconyTotalCost + this.constructionTotalCost;
        this.sumOfTotalCostsExcludeConstractionExcludeTaxes = this.unitTotalPrice + this.parkingTotalCost;
        this.totalAreaExludeParking = this.totalArea + this.shelterArea + this.balconiesSize + this.storageArea;
        this.lawyerFee = this.sumOfTotalCostsExcludeConstractionExcludeTaxes / 100 * 1.5;

      }
    }
  }
  saveOffer(pdfBlob) {
    this.blob = pdfBlob;
    this.sendQuotation();
    console.log(pdfBlob);
    this.uploadFile(pdfBlob)
  }
  uploadFile(file: any) {
    file.name = 'offer';
    const path = `${this.compId}/${this.projuId}/${new Date().getTime()}_${file.name}`;
    const customMetadata = { title: file.name };
    const fileRef = this.storage.ref(path);

    this.task = this.storage.upload(path, file, { customMetadata });
    this.percentage = this.task.percentageChanges();
    this.snapshot = this.task.snapshotChanges();

    this.task.snapshotChanges().pipe(
      finalize(() => {
        // Подписываемся на получение URL после загрузки файла
        fileRef.getDownloadURL().subscribe(downloadURL => {
          // Устанавливаем путь к файлу
          this.offer.path = downloadURL;

          if (!this.offer.user) {
            this.offer.user = {};
          }
          if(!this.user.phone){
            this.user.phone = 0;
          }
          this.offer.user.firstName = this.formData.firstName;
          this.offer.user.lastName = this.formData.lastName;
          this.offer.user.mobilePhone = this.formData.mobilePhone;
          this.offer.user.email= this.formData.email;
          this.offer.compId = this.compId;
          this.offer.uid = this.offer.user.id;
          this.offer.projuId = this.projuId;
          this.offer.seller = {
            name: this.user.displayName,
            phone: this.user.phone,
            email: this.user.email
          };

          this.calculatedProperties.forEach(property => {
            if (!this.offer.appartmentsIdArray) {
              this.offer.appartmentsIdArray = [];
            }
            let unit = {
              number: property.unitNumber,
              building: property.buildingId,
              buildTitle: property.buildTitle
            };
            this.offer.appartmentsIdArray.push(unit);
          });

          // Добавляем объект в Firestore после того, как получили downloadURL
          this.sendWhatsAppMessage(this.offer.user.id, this.offer.path, this.offer.user.mobilePhone, this.offer.appartmentsIdArray[0]);
          this.dataService.addItem(this.offer, 'offers');
        });
      })
    ).subscribe();
  }





  fetchProjectDetails(projectNumber: number): void {
    this.sye.getProjectDetails(projectNumber).subscribe(
      (response) => {
        console.log(response);
        this.unitsStatusAndStorageParkingAmountFromCRM.soldUnits = [];
        let records = JSON.parse(JSON.stringify(response));
        console.log(records['Assets Details']);
        this.unitsStatusAndStorageParkingAmountFromCRM.avalablePrkingAmount = records['Project Details'].ParkingSpotsAvailable;
        this.unitsStatusAndStorageParkingAmountFromCRM.avalableStorageAmount = records['Project Details'].StorageUnitsAvailable;
        records['Assets Details'].forEach(unit => {
          if (unit.MarketingStatus === "נמכר") {
            this.unitsStatusAndStorageParkingAmountFromCRM.soldUnits.push(unit.AssetNum);
          }
        })

      },
      (error) => {
        console.error('Error fetching project details:', error);
      }
    );
  }

  openPreview() {
    // this.calculatedProperties.length


// // Select all elements with the particular class
// const elements = document.querySelectorAll('.particular-unit');
// const elementInsertAfter = document.querySelectorAll('.units-container')[0];


// for (let i = 0; i < elements.length; i += 2) {
//     // Create a new container (e.g., a div)
//     const container = document.createElement('div');
//     container.classList.add('page'); // Optional: Add a class to the container

//     // Append the current element to the container
//     container.appendChild(elements[i]);

//     // Check if there's a next element and append it to the container
//     if (elements[i + 1]) {
//         container.appendChild(elements[i + 1]);
//     }

//     // Insert the new container before the first element
//     // elements[i].parentNode.insertBefore(container, elementInsertAfter);
//     elementInsertAfter.appendChild(container);
// }




    const offerElement = this.renderer.selectRootElement('#offer', true);
    const newElement = this.renderer.selectRootElement('#preview-container', true);
    this.renderer.appendChild(newElement, offerElement);
    this.showPreview = true;
    this.showPromt = false;

  }
  closePreview() {
    const offerElement = this.renderer.selectRootElement('#offer', true);
    const newElement = this.renderer.selectRootElement('#offer-top', true);
    this.renderer.appendChild(newElement, offerElement);
    this.showPreview = false;
  }
  openPromt() {
    this.showPromt = true;
  }
  closePromt() {
    this.showPromt = false;
  }

  sendQuotation() {
    if (!this.offer.user) {
      this.offer.user = {};
      if (!this.offer.user.id || this.offer.user.id === '') {
        this.offer.user.id = randomString(15);
      }
    }
    let properties: any = [];

    this.calculatedProperties.forEach(prop => {

      properties.push({
        CatalogicNumber: 'property', // id from unit
        PropertyId: prop.unitNumber,
        // ProductName: prop.unitNumber + 'נכס ' + prop.numberOfParkingSpaces + 'הכולל חניות' + prop.numberOfStoragesSpaces +  ', מחסנים ' , // description 
        ProductName: 'Property Details:' + prop.unitNumber + 'Storages Included:' + prop.numberOfStoragesSpaces + 'Parking Slots Included:' + prop.numberOfParkingSpaces, // description 
        UnitOfMeasure: 1,
        Quantity: 1,
        NetSalePrice: this.averagePricePerSqM * prop.officeArea +
          prop.constructionCost + this.parkingSpaceCost * prop.numberOfParkingSpaces +
          prop.parkingConstructionCost * prop.numberOfParkingSpaces,
        BuildCost: prop.constructionCost,
        LandCost: this.averagePricePerSqM * prop.officeArea,
        TotalNetLc: 0,
        BuildingId: prop.buildingId,
        PrintGroup: 0,
        TotalStorageLandCost: this.storageSpaceCost * prop.numberOfStoragesSpaces,
        TotalStorageUnits: prop.numberOfStoragesSpaces,
        TotalStorageBuildCost: this.constractionStorageCost * prop.numberOfStoragesSpaces,
        TotalParkingLandCosts: this.parkingSpaceCost * prop.numberOfParkingSpaces,
        TotalParkingSpaces: prop.numberOfParkingSpaces,
        TotalParkingBuildCost: this.parkingConstructionCost * prop.numberOfParkingSpaces,
        // Mone: prop.counter,
        // Mechane: prop.denominator,
        // fraction: prop.fraction,
      })



    });

    const quotationData = {
      "PoNumber": this.offer.user.id, // id offer
      "ProjectNumber": 25000000,
      "IssueDateTime": new Date(),
      "SalesAgent": this.SalesAgentFromCRM,
      "Agency": this.Agency,
      "Comments": "",
      "AvailableParkingSpots": 0,
      "MarketingCommission": this.marketingCommissionTotalCost,
      "LawyerCosts": this.lawyerFee,
      "LawyerCommission": this.lawyerFee,
      "Prefix": "",
      "Sufix": "",
      "TotalWithoutTax": this.sumOfTotalCostsExcludeConstractionExcludeTaxes,
      "TotalGrossLC": this.totalCostIncludeAllExludeTaxes * 1.17,  // מחיר ללקוח כלל הכל
      "TotalPaidForReservation": 0,
      "SqmaBulidCost_Unit_Storage": (this.unitTotalPrice + this.constructionTotalCost + this.balconyTotalCost + this.shelterTotalCost) / (this.totalArea + this.storageArea),
      "QuantitySqmaBuild_Unit_Storage": this.totalArea + this.storageArea,
      "TotalBuildCost_Unit_Storage": this.constructionTotalCost,
      "SqmaBulidCost_Parking": 0,
      "QuantitySqmaBuild_Parking": 0,
      "TotalBuildCost_Parking": this.parkingConstructionCost * this.numberOfParkingSpaces,
      "TotalBuildCost": this.constructionTotalCost + this.totalConstractionStorageCost + this.totalConstractionParkingCost,  // עלות בניה של יחידה + חניה + מחסנים
      "TotalBuildCost_Unit_Land": this.constructionTotalCost + this.unitTotalPrice, // עלות בניה + קרקע + 
      "TotalBuildCost_Unit_Land_Parking": this.constructionTotalCost + this.totalParkingCostWithConstruction + this.unitTotalPrice,// עלות בניה + קרקע + חניות
      "SqmaUnitBuildCost": 0, // עלות מטר עבור יחידה
      "Items": properties,
      "PdfBlob": this.blob,
      // "Items": [
      //   {
      //     "CatalogicNumber": "יחידה",
      //     "PropertyId": "ab2",
      //     "ProductName": "נכס צמוד קרקע",
      //     "UnitOfMeasure": 1,
      //     "Quantity": 99.37,
      //     "NetSalePrice": 12255,
      //     "BuildCost": 577173,
      //     "LandCost": 0,
      //     "TotalNetLc": 0,
      //     "BuildingId": "",
      //     "PrintGroup": 0
      //   },
      //   {
      //     "CatalogicNumber": "DIRA",
      //     "PropertyId": "",
      //     "ProductName": "דירה",
      //     "UnitOfMeasure": 1,
      //     "Quantity": 120,
      //     "NetSalePrice": 1200000,
      //     "BuildCost": 0,
      //     "LandCost": 0,
      //     "TotalNetLc": 0,
      //     "BuildingId": "",
      //     "PrintGroup": 0
      //   }
      // ],
      "Clients": [
        {
          "ClientNumber": this.ClientNumber,
          "FirstName": this.formData.firstName,
          "LastName": this.formData.lastName,
          "Id": "513227654", // ח.פ
          "Phone1": this.formData.mobilePhone,
          "Phone2": "",
          "Email": this.formData.email,
          "StreetAddress": this.formData.street + ", " + this.formData.buildingNumber,
          "City": this.formData.city,
          "ClientType": this.formData.city,
          "ClientLevel": ""
        }
      ]
    };
    console.log(quotationData);

    this.subscription = this.sye.postQuotation(quotationData).subscribe({
      next: (response) => {
        console.log('Success:', response);
      },
      error: (error) => {
        console.error('Error:', error);
      },
      complete: () => {
        console.log('Request complete');
      }
    });
  }
  showSearchResultsF($event) {
    this.showSearchResults = $event;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }


}

